<template>
  <div
    class="container mt-1"
    style="min-height: 500px;"
  >
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
      style="margin-top: -55px"
    >
      <div class="col-12-notyRun d-md-flex d-none">
        <div
          id="notyRun"
          class="col-12 col-md-12 card mb-1 pl-0"
        >
          <div
            v-if="dataNoty.length"
            class="d-flex card-body font-size16px"
            style=""
          >
            <div class="w-15 d-flex align-items-center">
              <span class="icon_thongbao mr-1" />
              <span class="font-weight-700 font-size20px">Thông báo:</span>
            </div>
            <div class="w-85 text-dark-1 font-size16px d-flex align-items-center">
              <marquee> {{ renderNoty(dataNoty) }} </marquee>
            </div>
          </div>
          <div
            v-else
            class="d-flex card-body font-size16px"
            style=""
          >
            <div class="w-10 d-flex align-items-center">
              <span class="iconHotGif mr-1" />
              <span class="font-weight-700 font-size20px">Tin hot:</span>
            </div>
            <div class="w-90 text-dark-1 font-size16px d-flex align-items-center">
              <marquee
                id="marquee1"
                onmouseover="this.stop();"
                onmouseout="this.start();"
                class="news-title"
              >
                <router-link
                  v-for="(data) in dataHotItems"
                  :key="data.id"
                  :to="{ name: 'home-view', params: { id: data.id, slug: data.slug } }"
                  class=" class_title_hot_notget_view "
                  :title="data.title"
                >
                  <span> {{ data.title }}</span>

                </router-link>
              </marquee>
            </div>

          </div>
        </div>
      </div>
      <div class="row row-sm">
        <div
          id="newsLast"
          class="col-12 col-md-8"
        >
          <hot-view :items="dataNewLatestItems" />
        </div>
        <div
          id="photoImage"
          class="col-12 col-md-4 mb-1 mb-mb-0"
        >
          <div
            v-if="checkClassShowNews === 2"
            class="showCountNews font-be-vietnam"
          >
            <div class="card counter-list sticky-top mb-1">
              <div
                v-if="dataCountNews.is_corrected === 2"
                class="counter-item"
              >
                <b-link
                  :to="{ name: 'article-corrected' }"
                  class="d-flex"
                >
                  <div class="counter-icon">
                    <span class="icon icon_cho_xuat_ban" />
                  </div>
                  <div class="counter-states">
                    <span class="font-size16px font-weight-700 text-dark"> {{ dataCountNews.count_article_corrrected }}</span>
                    <span class="text-dark-3">Chờ xuất bản</span>
                  </div>
                </b-link>
              </div>
              <div
                v-if="dataCountNews.is_approved === 2"
                class="counter-item"
              >
                <b-link
                  :to="{ name: 'article-approved' }"
                  class="d-flex"
                >
                  <div class="counter-icon">
                    <span class="icon icon_cho_duyet" />
                  </div>
                  <div class="counter-states">
                    <span class="font-size16px font-weight-700 text-dark"> {{ dataCountNews.count_article_approved }}</span>
                    <span class="text-dark-3">Chờ duyệt</span>
                  </div>
                </b-link>
              </div>
              <div
                v-if="dataCountNews.is_allow_edit_draft === 2"
                class="counter-item"
              >
                <b-link
                  :to="{ name: 'article-draft' }"
                  class="d-flex"
                >
                  <div class="counter-icon">
                    <span class="icon icon_nho_xu_ly" />
                  </div>
                  <div class="counter-states">
                    <span class="font-size16px font-weight-700 text-dark"> {{ dataCountNews.count_article_draft }}</span>
                    <span class="text-dark-3">Nhờ xử lý</span>
                  </div>
                </b-link>
              </div>
            </div>
          </div>
          <photo-view
            :items="dataPostImage"
            :max-height="checkClassShowNews === 2 ? 412 : 500"
          />
        </div>
      </div>
      <!--  Số lượng tin bài khi cuộn -->
      <div
        v-if="checkClassShowNews === 2"
        class="row font-be-vietnam"
        :class="classShowCountNews"
      >
        <div class="col-12">
          <div class="card counter-list sticky-top p-1 mb-0">
            <div class="w-100 text-center counter-item">
              <b-link
                v-if="dataCountNews.is_corrected === 2"
                class=" font-size16px font-weight-700 text-dark"
                :to="{ name: 'article-corrected' }"
                title="Chờ xuất bản"
              >
                <div
                  v-if="dataCountNews.is_corrected === 2"
                  class="icon icon_cho_xuat_ban"
                  title="Chờ xuất bản"
                />
                <div class="text-dark">
                  {{ dataCountNews.count_article_corrrected }}
                </div>
              </b-link>
            </div>
            <div class="w-100 text-center counter-item">
              <b-link
                v-if="dataCountNews.is_approved === 2"
                class=" font-size16px font-weight-700 text-dark"
                :to="{ name: 'article-approved' }"
                title="Chờ duyệt"
              >
                <div
                  v-if="dataCountNews.is_approved === 2"
                  class="icon_cho_duyet"
                  title="Chờ duyệt"
                />
                <div class=" text-dark">
                  {{ dataCountNews.count_article_approved }}
                </div>
              </b-link>
            </div>
            <div class="w-100 text-center counter-item">
              <b-link
                v-if="dataCountNews.is_allow_edit_draft === 2"
                class=" font-size16px font-weight-700 text-dark"
                :to="{ name: 'article-draft' }"
                title="Nhờ xử lý"
              >
                <div
                  v-if="dataCountNews.is_allow_edit_draft === 2"
                  class="icon_nho_xu_ly"
                  title="Nhờ xử lý"
                />
                <div class="text-dark">
                  {{ dataCountNews.count_article_draft }}
                </div>
              </b-link>
            </div>
          </div>
        </div>
      </div>
      <!-- Banner -->
      <banner-view :banner-content="bannerContent" />
      <!--  Phòng ban -->
      <div class="row row-sm">
        <div
          v-for="(item, index) in dataArticleOfPart "
          :key="index"
          class="col-md-4 mb-1"
        >
          <list-part-view
            :item="item"
            :show-icon="renderIcon(index)"
          />
        </div>
      </div>
      <!-- Chi dao thong tin + Giao ban dai + Tai lieu tham khao -->
      <div class="row row-sm">
        <div
          id="propagate"
          class="col-md-4"
        >
          <propagate-box
            :items="dataBriefings"
            :title-name="'Giao ban đài'"
            :slug-name="'giao-ban-dai'"
          />
        </div>
        <div
          id="propagate"
          class="col-md-4"
        >
          <propagate-box
            :items="dataPropagate"
            :title-name="'Chỉ đạo thông tin'"
            :slug-name="'chi-dao-thong-tin'"
          />
        </div>
        <div
          id="propagate"
          class="col-md-4"
        >
          <propagate-box
            :items="dataReferenceDocuments"
            :title-name="'Tài liệu tham khảo'"
            :slug-name="'tai-lieu-tham-khao'"
          />
        </div>
      </div>
      <!-- Video -->
      <div class="row  ">
        <div class="col-12 mb-1">
          <slider-view
            class=""
            :item="dataPostVideo"
          />
        </div>
      </div>
      <!-- Chuyen muc -->
      <div class="row row-sm">
        <div
          v-for="(item, index) in dataArticleOfCategory "
          id="listView"
          :key="index"
          class="col-md-3 mb-1"
        >
          <list-view
            :item="item"
            :show-icon="renderIcon(index)"
          />
        </div>
        <div class="col-md-3 mb-1">
          <audio-view :items="dataPostAudio" />
        </div>
      </div>
      <!-- Tin audio và tin video  -->
      <!-- <div class="row row-sm">
        <div class="col-md-6 col-12">
          <audio-view :items="dataPostAudio" />
        </div>
        <div
          id="postVideo"
          class="col-md-6 col-12"
        >
          <video-view
            :items="dataPostVideo"
            class="large-thumb"
          />
        </div>
      </div> -->
    </b-overlay>
    <facebook />
    <zalo />

  </div>
</template>
<script>
import {
  BOverlay, BLink,

} from 'bootstrap-vue';
import { ref, computed } from '@vue/composition-api';
import store from '@/store';
import { showToast } from '@core/utils/utils';
import PropagateBox from './components/PropagateBox.vue';
import HotView from './components/HotView.vue';
import PhotoView from './components/PhotoView.vue';
import AudioView from './components/AudioView.vue';
import VideoView from './components/VideoView.vue';
import ListView from './components/ListView.vue'
import ListPartView from './components/ListPartView.vue'
import SliderView from './components/SliderView.vue'
import BannerView from './components/BannerView.vue'
import Facebook from './Facebook.vue'
import Zalo from './Zalo.vue'

export default {
  components: {
    BOverlay,
    ListView,
    PropagateBox,
    HotView,
    PhotoView,
    AudioView,
    VideoView,
    BannerView,
    SliderView,
    ListPartView,
    BLink,
    Facebook,
    Zalo,
  },
  computed: {
    updateListData: {
      set() { },
      get() { return this.$store.state.article.article_home_published },
    },
    updateHomeNewsCount: {
      set() { },
      get() { return this.$store.state.article.article_home_count },
    },
    classShowCountNews: {
      get() {
        return store.state.home.classShowCountNews
      },
      set(val) {
        store.dispatch('home/setClassShowCountNews', val)
      },
    },
  },
  watch: {
    updateListData() {
      this.refetchData()
    },
    updateHomeNewsCount() {
      this.countNews()
      const list_data = {
        article_home_count: false,
      };
      store.dispatch('article/setState', list_data);
    },
  },
  methods: {
    renderIcon(index) {
      return this.listIcon[index]
    },
    renderNoty(data) {
      return data.join(' - ')
    },
  },
  setup() {
    const dataItems = ref([])
    const dataNewLatestItems = ref([])
    const dataHotItems = ref([])
    const dataPostImage = ref([])
    const dataPostAudio = ref([])
    const dataPostVideo = ref(null)
    const dataPropagate = ref([])
    const dataBriefings = ref([])
    const dataReferenceDocuments = ref([])
    const dataArticleOfCategory = ref([])
    const dataArticleOfPart = ref([])
    const dataNoty = ref([])
    const dataBeamImage = ref({})
    const dataCountNews = ref([])
    const bannerContent = ref(null)
    const checkClassShowNews = ref(1)
    const listIcon = [
      'GlobeIcon', 'BarChart2Icon', 'BriefcaseIcon', 'BookIcon', 'CodepenIcon', 'FileMinusIcon', 'GridIcon', 'OctagonIcon',
    ]
    // const appSetting = computed(() => store.state.app.settings); console.log('fb', appSetting)
    const loading = ref(true)
    const fetchAll = () => {
      store.dispatch('home/fetchAll').then(response => {
        const result = response.data;
        //   console.log('result, ', result);
        loading.value = false
        if (result.code === 200) {
          dataItems.value = result.data;
          dataNewLatestItems.value = result.data.lastNews;
          dataHotItems.value = result.data.hotItems;
          // dataPostImage.value = result.data.postImage;
          // dataPostAudio.value = result.data.postAudio;
          // dataPostVideo.value = result.data.postVideo;
          // dataPropagate.value = result.data.propagate;
          // dataReferenceDocuments.value = result.data.reference_documents;
          // dataBriefings.value = result.data.briefings;
        } else {
          showToast(result.message)
        }
      })
    }
    fetchAll()
    const fetchAllPhoto = () => {
      store.dispatch('home/fetchAllPhoto').then(response => {
        const result = response.data;
        //   console.log('result, ', result);
        loading.value = false
        if (result.code === 200) {
          dataPostImage.value = result.data.postImage;
        } else {
          showToast(result.message)
        }
      })
    }
    fetchAllPhoto()
    const fetchAllVideo = () => {
      store.dispatch('home/fetchAllVideo').then(response => {
        const result = response.data;
        //   console.log('result, ', result);
        loading.value = false
        if (result.code === 200) {
          dataPostVideo.value = {
            content_type: 'news',
            id: '0',
            name: 'Tin Video',
            slug: 'video',
            articles: result.data.postVideo,
          }
          console.log('dataPostVideo.value', dataPostVideo.value);
        } else {
          showToast(result.message)
        }
      })
    }
    fetchAllVideo()
    const fetchAllAudio = () => {
      store.dispatch('home/fetchAllAudio').then(response => {
        const result = response.data;
        //   console.log('result, ', result);
        loading.value = false
        if (result.code === 200) {
          dataPostAudio.value = result.data.postAudio;
        } else {
          showToast(result.message)
        }
      })
    }
    fetchAllAudio()
    const fetchAllPropagate = () => {
      store.dispatch('home/fetchAllPropagate').then(response => {
        const result = response.data;
        //   console.log('result, ', result);
        loading.value = false
        if (result.code === 200) {
          dataPropagate.value = result.data.propagate;
        } else {
          showToast(result.message)
        }
      })
    }
    fetchAllPropagate()
    const fetchAllReferenceDocument = () => {
      store.dispatch('home/fetchAllReferenceDocument').then(response => {
        const result = response.data;
        //   console.log('result, ', result);
        loading.value = false
        if (result.code === 200) {
          dataReferenceDocuments.value = result.data.reference_documents;
        } else {
          showToast(result.message)
        }
      })
    }
    fetchAllReferenceDocument()
    const fetchAllBrefings = () => {
      store.dispatch('home/fetchAllBrefings').then(response => {
        const result = response.data;
        //   console.log('result, ', result);
        loading.value = false
        if (result.code === 200) {
          dataBriefings.value = result.data.briefings;
        } else {
          showToast(result.message)
        }
      })
    }
    fetchAllBrefings()

    const refetchData = () => {
      fetchAll()
      const list_data = {
        article_home_published: false,
      };
      store.dispatch('article/setState', list_data);
    }

    const fetchArticleOfCategory = () => {
      store.dispatch('home/fetchArticleOfCategory').then(response => {
        const result = response.data;
        console.log('result, ', result);
        loading.value = false
        if (result.code === 200) {
          dataArticleOfCategory.value = result.data;
          console.log(dataArticleOfCategory);
        } else {
          showToast(result.message)
        }
      })
    }
    fetchArticleOfCategory()
    const fetchArticleOfPart = async () => {
      store.dispatch('home/fetchArticleOfPart').then(response => {
        const result = response.data;

        loading.value = false
        if (result.code === 200) {
          dataArticleOfPart.value = result.data;
        } else {
          showToast(result.message)
        }
      })
    }
    fetchArticleOfPart()

    const fetchBeamImage = () => {
      store.dispatch('home/fetchBeamImage').then(response => {
        const result = response.data;

        loading.value = false
        if (result.code === 200) {
          console.log('fetchBeamImage', result)
          dataBeamImage.value = result.data;
          console.log('dataBeamImage.value', dataBeamImage.value);
        } else {
          showToast(result.message)
        }
      })
    }
    fetchBeamImage()

    store.dispatch('home/notification').then(response => {
      const result = response.data;
      if (result.code === 200) {
        // console.log('result_notif', result.data);
        dataNoty.value = result.data
      }
    })
    const countNews = () => {
      store.dispatch('home/countNews').then(response => {
        const result = response.data;
        if (result.code === 200) {
          dataCountNews.value = result.data
          if (dataCountNews.value.is_corrected === 2 || dataCountNews.value.is_approved === 2 || dataCountNews.value.is_allow_edit_draft === 2) {
            checkClassShowNews.value = 2
          }
        }
      })
    }
    countNews()

    return {
      dataItems,
      dataNewLatestItems,
      dataPostImage,
      dataPostAudio,
      dataPostVideo,
      dataPropagate,
      dataArticleOfCategory,
      loading,
      listIcon,
      refetchData,
      dataArticleOfPart,
      dataBeamImage,
      dataBriefings,
      dataReferenceDocuments,
      dataNoty,
      dataCountNews,
      checkClassShowNews,
      bannerContent,
      countNews,
      dataHotItems,
      // appSetting,
    };
  },
};
</script>
<style lang="scss">
.showCountNews {
  padding: 0 0.5rem;

  .counter-list {
    display: flex;
    flex-direction: row;
    margin: 0 -0.5rem;

    .counter-item {
      padding: 1rem 0.5rem;
      flex: 1 1 auto;

      .counter-icon {
        .icon {
          width: 40px;
          height: 40px;
        }
      }

      .counter-states {
        display: flex;
        flex-direction: column;
        margin-left: 5px;
      }
    }
  }
}

.showCountNewsRight {
  position: fixed;
  right: 0;
  top: 40%;
  z-index: 9999;

  .counter-list {
    margin-bottom: 0;

    .counter-item:not(:last-child) {
      margin-bottom: 15px;
    }
  }
}

.hideCountNewsRight {
  display: none
}

.heightShowNews {
  height: 80px;
  max-height: 80px
}

#marquee1 {
  a {
    position: relative;
    margin-right: 10px;
    padding: 0px 5px;
    -webkit-animation: marquee 50000ms linear infinite;
    animation: marquee 50000ms linear infinite;

    &:before {
      content: "";
      position: absolute;
      height: 80%;
      border-right: solid 1px #ccc;
      top: 3px;
      right: -6px;
    }
  }
}
</style>
